// cookieの整形オブジェクト
export interface HistoryIdFormat {
  id: string;
  date: string;
  viewNum: string;
}

/**
 * cookieのHISTORYIDを配列へ整形
 * @param {string} historyId
 * @return {HistoryIdFormat[]} 閲覧履歴IDリスト
 */
export const cookieHistoryIdFormat = (historyId: string): HistoryIdFormat[] =>
  historyId
    .split(';')
    ?.map((cookie) => {
      const splitCookie = cookie.split(',');
      return {
        id: splitCookie[0] || '',
        date: splitCookie[1] || '',
        viewNum: splitCookie[2] || '0',
      };
    })
    .filter((history) => !!history.id);
